import React, { useContext, useEffect, useState } from "react";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";
import { ThemeContext } from "../../../../context/ThemeContext";
import { Link } from "react-router-dom";
import { SVGICON } from "../../../constant/theme";
import TestingOverviewTab from "../Dashboard/TestingOverviewTab";
import ActiveInward from "../Dashboard/ActiveInward";
import TopCustomer from "../Dashboard/TopCustomer";
import TopTests from "../Dashboard/TopTests";
import TopDepartments from "../Dashboard/TopDepartments";
import TopMachines from "../Dashboard/TopMachines";
import InwardDispatch from "../Dashboard/InwardDispatch";
import {
  POST_GetActivityLogData,
  POST_GetTodaysSummaryData,
} from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import TestingOverviewChart from "../Dashboard/TestingOverviewChart";

const Dashboard = () => {
  // const { changeBackground } = useContext(ThemeContext);
  const [isLoading, setIsLoading] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [testingMonthWiseData, setTestingMonthWiseData] = useState([]);
  const [todaysInwardCount, setTodaysInwardCount] = useState(0);
  const [
    todaysInwardApprovalPendingCount,
    setTodaysInwardApprovalPendingCount,
  ] = useState("");
  const [
    todaysTestingApprovalPendingCount,
    setTodaysTestingApprovalPendingCount,
  ] = useState("");

  const [todaysReportDispatchCount, setTodaysReportDispatchCount] =
    useState("");
  const [todaysTestingCount, setTodaysTestingCount] = useState("");

  const [activityLogDataList, setActivityLogData] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    //changeBackground({ value: "light", label: "Light" });
    getActivityLogData();
    getDashboardDetails();
  }, []);

  useEffect(() => {
    getActivityLogData();
  }, [searchText]);

  const getDashboardDetails = async () => {
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    };

    await post(POST_GetTodaysSummaryData, payload)
      .then((response) => {
        setTodaysInwardCount(response?.TodaysInwardCount);
        setTodaysInwardApprovalPendingCount(
          response?.TodaysInwardApprovalPendingCount
        );
        setTodaysTestingApprovalPendingCount(
          response?.TodaysTestingApprovalPendingCount
        );
        setTodaysReportDispatchCount(response?.TodaysReportDispatchCount);
        setTodaysTestingCount(response?.TodaysTestingCount);
        setTestingMonthWiseData(response?.TestingMonthWiseData);

        var obj = JSON.parse(localStorage.getItem("userDetails"));
        obj.IsBranchDefinationComplate = response?.IsBranchDefinationComplate;
        obj.IsBroadcastEmailSetup = response?.IsBroadcastEmailSetup;
        obj.IsInwardEmailSetup = response?.IsInwardEmailSetup;
        obj.IsDispatchReportEmailSetup = response?.IsDispatchReportEmailSetup;
        obj.IsUploadScanCopyEmailSetup = response?.IsUploadScanCopyEmailSetup;
        obj.IsMachineCalibrationEmailSetup =
          response?.IsMachineCalibrationEmailSetup;
        obj.IsInvoiceEmailSetup = response?.IsInvoiceEmailSetup;
        localStorage.setItem("userDetails", JSON.stringify(obj));

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getActivityLogData = async () => {
    setIsLoading(true);

    let payload = {
      EmployeeIDEncrypted: AuthUser?.ReferenceIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      SearchText: searchText,
    };

    await post(POST_GetActivityLogData, payload)
      .then((response) => {
        setActivityLogData(response?.List);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      {/* <MainPagetitle
    mainTitle="Dashboard"
    pageTitle="Dashboard"
    parentTitle="Home"
  /> */}

      <div className="container-fluid p-3">
        <div className="row">
          {/* <div className="col-lg-9 ps-2"> */}
          <div
            className={`${
              AuthUser?.UserType !== 1 ||
              AuthUser?.Permissions?.FormList?.filter(
                (x) => x?.FormID == 78 && x?.IsRead
              )?.length > 0
                ? "col-lg-9 ps-2"
                : "col-lg-12 ps-2"
            } ps-2`}
          >
            <div className="row">
              {/* <div className="col-xl-3 col-sm-6 col-lg-6 pe-1"> */}
              {AuthUser?.UserType !== 1 ||
              AuthUser?.Permissions?.FormList?.filter(
                (x) => x?.FormID == 65 && x?.IsRead
              )?.length > 0 ? (
                <div
                  className={`${
                    AuthUser?.Permissions?.ApprovalWorkflow !== 1
                      ? "col-xl-6 col-sm-12 col-lg-12"
                      : AuthUser?.Permissions?.InwardApprovalRequired ==
                          false &&
                        AuthUser?.Permissions?.InwardApprovalRequired == false
                      ? "col-xl-6 col-sm-12 col-lg-12"
                      : AuthUser?.Permissions?.InwardApprovalRequired == true &&
                        AuthUser?.Permissions?.InwardApprovalRequired == true
                      ? "col-xl-3 col-sm-6 col-lg-6"
                      : "col-xl-4 col-sm-4 col-lg-4"
                  } pe-1`}
                >
                  <div
                    className="widget-stat card mb-2"
                    style={{ height: "calc(100% - 10px)" }}
                  >
                    <div className="card-body p-2">
                      <div className="media ai-icon">
                        <span className="me-2 bgl-warning text-warning">
                          {SVGICON.InwardToday}
                        </span>
                        <div className="media-body">
                          <p className="mb-1">Today's Inwards</p>
                          <h4 className="mb-0">{todaysInwardCount}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {/* <div className="col-xl-3 col-sm-6 col-lg-6 pe-1"> */}
              {AuthUser?.UserType !== 1 ||
              AuthUser?.Permissions?.FormList?.filter(
                (x) => x?.FormID == 66 && x?.IsRead
              )?.length > 0 ? (
                <div
                  className={`${
                    AuthUser?.Permissions?.ApprovalWorkflow !== 1
                      ? "col-xl-6 col-sm-12 col-lg-12"
                      : AuthUser?.Permissions?.InwardApprovalRequired ==
                          false &&
                        AuthUser?.Permissions?.InwardApprovalRequired == false
                      ? "col-xl-6 col-sm-12 col-lg-12"
                      : AuthUser?.Permissions?.InwardApprovalRequired == true &&
                        AuthUser?.Permissions?.InwardApprovalRequired == true
                      ? "col-xl-3 col-sm-6 col-lg-6"
                      : "col-xl-4 col-sm-4 col-lg-4"
                  } pe-1`}
                >
                  <div
                    className="widget-stat card mb-2"
                    style={{ height: "calc(100% - 10px)" }}
                  >
                    <div className="card-body p-2">
                      <div className="media ai-icon">
                        <span className="me-2 bgl-success text-success">
                          {SVGICON.TotalTest}
                        </span>
                        <div className="media-body">
                          <p className="mb-1"> Today's Testing | Report</p>
                          <h4 className="mb-0">{todaysReportDispatchCount}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
              AuthUser?.Permissions?.InwardApprovalRequired == true ? (
                // <div className="col-xl-3 col-sm-6 col-lg-6 pe-1">
                AuthUser?.UserType !== 1 ||
                AuthUser?.Permissions?.FormList?.filter(
                  (x) => x?.FormID == 67 && x?.IsRead
                )?.length > 0 ? (
                  <div
                    className={`${
                      AuthUser?.Permissions?.TestingApprovalRequired == true
                        ? "col-xl-3 col-sm-6 col-lg-6"
                        : "col-xl-4 col-sm-4 col-lg-4"
                    } pe-1`}
                  >
                    <div
                      className="widget-stat card mb-2"
                      style={{ height: "calc(100% - 10px)" }}
                    >
                      <div className="card-body p-2">
                        <Link
                          title="Inward Approval Pending"
                          to="/tc-test-allocation-list"
                        >
                          <div className="media ai-icon">
                            <span className="me-2 bgl-primary text-primary">
                              {SVGICON.NewCustomer}
                            </span>
                            <div className="media-body">
                              <p className="mb-1">Inward Approval Pending</p>
                              <h4 className="mb-0">
                                {todaysInwardApprovalPendingCount}
                              </h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
              {AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
              AuthUser?.Permissions?.TestingApprovalRequired == true ? (
                // <div className="col-xl-3 col-sm-6 col-lg-6 pe-1">
                AuthUser?.UserType !== 1 ||
                AuthUser?.Permissions?.FormList?.filter(
                  (x) => x?.FormID == 68 && x?.IsRead
                )?.length > 0 ? (
                  <div
                    className={`${
                      AuthUser?.Permissions?.InwardApprovalRequired == true
                        ? "col-xl-3 col-sm-6 col-lg-6"
                        : "col-xl-4 col-sm-4 col-lg-4"
                    } pe-1`}
                  >
                    <div
                      className="widget-stat card mb-2"
                      style={{ height: "calc(100% - 10px)" }}
                    >
                      <div className="card-body p-2">
                        <Link
                          title="Testing Approval Pending"
                          to="/testing-list"
                        >
                          <div className="media ai-icon">
                            <span className="me-2 bgl-danger text-danger">
                              {SVGICON.TotalCustomer}
                            </span>
                            <div className="media-body">
                              <p className="mb-1">Testing Approval Pending </p>
                              <h4 className="mb-0">
                                {todaysTestingApprovalPendingCount}
                              </h4>
                            </div>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </div>
            <div className="row">
              {AuthUser?.UserType !== 1 ||
              AuthUser?.Permissions?.FormList?.filter(
                (x) => x?.FormID == 70 && x?.IsRead
              )?.length > 0 ? (
                <div className="col-xl-6 col-sm-12 col-lg-12 pe-1">
                  <TestingOverviewChart />
                </div>
              ) : (
                ""
              )}
              {AuthUser?.UserType !== 1 ||
              AuthUser?.Permissions?.FormList?.filter(
                (x) => x?.FormID == 71 && x?.IsRead
              )?.length > 0 ? (
                <div className="col-xl-6 col-sm-12 col-lg-12 pe-1">
                  <TopCustomer title="Top Customer" />
                </div>
              ) : (
                ""
              )}

              {/* <div className="col-lg-6 ps-2 pe-2"> */}
              {AuthUser?.UserType !== 1 ||
              AuthUser?.Permissions?.FormList?.filter(
                (x) => x?.FormID == 72 && x?.IsRead
              )?.length > 0 ? (
                <div className="col-xl-6 col-sm-12 col-lg-12 pe-1">
                  <TopTests title="Top Tests" />
                </div>
              ) : (
                ""
              )}
              {/* <div className="col-lg-6 ps-2 pe-2"> */}
              {AuthUser?.UserType !== 1 ||
              AuthUser?.Permissions?.FormList?.filter(
                (x) => x?.FormID == 73 && x?.IsRead
              )?.length > 0 ? (
                <div className="col-xl-6 col-sm-12 col-lg-12 pe-1">
                  <TopDepartments title="Top Departments" />
                </div>
              ) : (
                ""
              )}
              {/* <div className="col-lg-6 ps-2 pe-2"> */}
              {AuthUser?.UserType !== 1 ||
              AuthUser?.Permissions?.FormList?.filter(
                (x) => x?.FormID == 74 && x?.IsRead
              )?.length > 0 ? (
                <div className="col-xl-6 col-sm-12 col-lg-12 pe-1">
                  <TopMachines title="Top Machine" />
                </div>
              ) : (
                ""
              )}
              {/* <div className="col-lg-6 ps-2 pe-2"> */}
              {AuthUser?.UserType !== 1 ||
              AuthUser?.Permissions?.FormList?.filter(
                (x) => x?.FormID == 75 && x?.IsRead
              )?.length > 0 ? (
                <div className="col-xl-6 col-sm-12 col-lg-12 pe-1">
                  <InwardDispatch />
                </div>
              ) : (
                ""
              )}
              {AuthUser?.UserType !== 1 ||
              AuthUser?.Permissions?.FormList?.filter(
                (x) => x?.FormID == 77 && x?.IsRead
              )?.length > 0 ? (
                AuthUser?.Permissions?.FormList?.filter(
                  (x) =>
                    [70, 71, 72, 73, 74, 75].includes(x?.FormID) && x?.IsRead
                )?.length <= 3 ? (
                  <div className="col-lg-12 ps-2 pe-2">
                    <ActiveInward />
                  </div>
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </div>
          </div>
          {AuthUser?.UserType !== 1 ||
          AuthUser?.Permissions?.FormList?.filter(
            (x) => x?.FormID == 78 && x?.IsRead
          )?.length > 0 ? (
            <div className="col-lg-3 pe-2">
              <div
                className="card mb-2"
                style={{ height: "calc(100% - 10px)" }}
              >
                <div className="card-body p-0">
                  <div className="d-flex justify-content-between mb-0 p-3 pt-2 pb-0">
                    <h4 className="heading">Activity Log</h4>
                    <span
                      className="pt-1 text-light"
                      style={{ fontSize: "0.76rem" }}
                    >
                      Recent 50
                    </span>
                  </div>
                  <div className="mb-2 p-3 pt-0 pb-1">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm"
                      onChange={(e) => {
                        setSearchText(e?.target?.value ?? "");
                      }}
                    ></input>
                  </div>
                  <hr className="mb-0 mt-0"></hr>
                  <div className="widget-media dz-scroll to-dodroup">
                    <ul className="timeline">
                      {activityLogDataList?.length > 0
                        ? activityLogDataList?.map((item, indx) => (
                            <Link
                              key={indx}
                              to={
                                item?.TranType == 1
                                  ? `/tc-test-allocation/${window.btoa(
                                      item?.TranRefIDEncrypt
                                    )}`
                                  : item?.TranType == 2
                                  ? `/add-inward-approval/${window.btoa(
                                      item?.TranRefIDEncrypt
                                    )}`
                                  : item?.TranType == 3
                                  ? `/tc-test-allocation/${window.btoa(
                                      item?.TranRefIDEncrypt
                                    )}`
                                  : item?.TranType == 4
                                  ? `/add-machining-outward`
                                  : item?.TranType == 5
                                  ? `/testing-list`
                                  : item?.TranType == 6
                                  ? `/tc-test-allocation/${window.btoa(
                                      item?.TranRefIDEncrypt
                                    )}`
                                  : item?.TranType == 7
                                  ? `/report-printing-list`
                                  : item?.TranType == 8
                                  ? `/report-dispatch-list`
                                  : item?.TranType == 10
                                  ? `/testing-list`
                                  : ""
                              }
                            >
                              <li key={indx}>
                                <div
                                  className="timeline-panel"
                                  style={{ cursor: "default" }}
                                >
                                  <div className="media ms-2 me-2 media-primary">
                                    {item.EmployeePhoto ? (
                                      <img
                                        alt="images"
                                        width={50}
                                        src={item.EmployeePhoto}
                                      />
                                    ) : (
                                      item?.Header?.substring(
                                        0,
                                        2
                                      )?.toUpperCase()
                                    )}
                                  </div>
                                  <div className="media-body">
                                    <h4 className="mb-1 media-header">
                                      {item.Header}
                                    </h4>
                                    {item.Line1 ? (
                                      <>
                                        <small className="d-block">
                                          {item.Line1}
                                        </small>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    {item.Line2 ? (
                                      <>
                                        <small className="d-block text-dark">
                                          {item.Line2}
                                        </small>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    {item.Description ? (
                                      <>
                                        <small className="d-block text-dark">
                                          {item.Description}
                                        </small>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    <small className="d-block text-light">
                                      {item.ActivityLogDate}
                                    </small>
                                  </div>
                                </div>
                              </li>
                            </Link>
                          ))
                        : ""}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {AuthUser?.UserType !== 1 ||
          AuthUser?.Permissions?.FormList?.filter(
            (x) => x?.FormID == 77 && x?.IsRead
          )?.length > 0 ? (
            AuthUser?.Permissions?.FormList?.filter(
              (x) => [70, 71, 72, 73, 74, 75].includes(x?.FormID) && x?.IsRead
            )?.length > 3 ? (
              <div className="col-lg-12 ps-2 pe-2">
                <ActiveInward />
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
